import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { pageSizeList, unionTypeList, kindList } from "@/utils/constant";
import {
    Button,
    Table,
    message,
    DatePicker,
    Modal,
    Pagination,
    Select,
    Cascader,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class DiamondOpeningStartStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        recordLoading: false, // 流水是否加载中
        exportLoading: false, // 导出是否加载中
        exportRecordLoading: false, // 导出流水是否加载中
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            kpoker_mode: -1,
            origin_id: undefined,
            origin_ids: [],
            date: [],
        },
        subQueryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            kpoker_mode: -1,
            origin_id: undefined,
            origin_ids: [],
            game_kind: undefined,
            date: [],
        },
        kindList: kindList, // 游戏类型列表
        data: [], // 表格数据
        subUnionList: [
            { union_id: 0, union_name: this.props.language["currentSuperUnion"] },
        ], // 子联盟列表
        recordData: [], // 流水数据
        unionTypeList: unionTypeList, // 联盟类型列表
    };

    componentDidMount () {
        if (Cookie.get("unionType") === "super_union") {
            this.fetchSubUnionList();
        }
        this.fetchData();
    }

    /**
     * 获取子联盟列表
     */
    fetchSubUnionList = () => {
        axios.get("/v1/api/union_select_list?kpoker_mode=-1").then((res) => {
            // 转换数据结构
            const modeMap = Object.fromEntries(
                this.state.unionTypeList.map(item => [item.value, item.label])
            );
            const resultMap = {};
            const list = res.data || []
            list.forEach(item => {
                const key = item.kpoker_mode;
                if (!resultMap[key]) {
                    resultMap[key] = {
                        value: key,
                        label: modeMap[key],
                        children: []
                    };
                }
                resultMap[key].children.push({
                    value: item.union_id,
                    label: `${item.union_name}（${item.union_id}）`,
                });
            });

            this.setState({
                subUnionList: Object.values(resultMap),
            });
        });
    };

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/diamond/opening_stat_list", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    kpoker_mode: this.state.queryParams.origin_ids.length ? this.state.queryParams.origin_ids[0] : - 1,
                    origin_id: this.state.queryParams.origin_ids[1] || -1,
                    origin_ids: undefined,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/diamond/export_opening_stat_list", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    kpoker_mode: this.state.queryParams.origin_ids.length ? this.state.queryParams.origin_ids[0] : - 1,
                    origin_id: this.state.queryParams.origin_ids[1] || -1,
                    origin_ids: undefined,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 获取流水数据
     */
    fetchRecordData = () => {
        this.setState({ recordLoading: true });
        axios
            .get("/v1/api/diamond/opening_log_list", {
                params: {
                    ...this.state.subQueryParams,
                    begin_time:
                        this.state.subQueryParams.date[0] &&
                        this.state.subQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.subQueryParams.date[1] &&
                        this.state.subQueryParams.date[1].startOf("day").valueOf() / 1000,
                    kpoker_mode: this.state.subQueryParams.origin_ids.length ? this.state.subQueryParams.origin_ids[0] : - 1,
                    origin_id: this.state.subQueryParams.origin_ids[1] || -1,
                    origin_ids: undefined,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    recordLoading: false,
                    subQueryParams: {
                        ...this.state.subQueryParams,
                        total: res.count || 0,
                    },
                    recordData: res.data || [],
                });
            });
    };

    /**
     * 导出流水数据
     */
    handleRecordExport = () => {
        this.setState({ exportRecordLoading: true });
        axios
            .get("/v1/api/diamond/export_opening_log_list", {
                params: {
                    ...this.state.subQueryParams,
                    begin_time:
                        this.state.subQueryParams.date[0] &&
                        this.state.subQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.subQueryParams.date[1] &&
                        this.state.subQueryParams.date[1].startOf("day").valueOf() / 1000,
                    kpoker_mode: this.state.subQueryParams.origin_ids.length ? this.state.subQueryParams.origin_ids[0] : - 1,
                    origin_id: this.state.subQueryParams.origin_ids[1] || -1,
                    origin_ids: undefined,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportRecordLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "record") {
            // 流水数据
            this.setState(
                {
                    subQueryParams: {
                        ...this.state.subQueryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchRecordData()
            );
        } else {
            // 表格数据
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "record") {
            // 流水数据
            this.setState({
                subQueryParams: { ...this.state.subQueryParams, page: 1, [key]: value },
            });
        } else {
            // 表格数据
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        }
    };

    /**
     * 重置
     */
    handleReset = (type) => {
        if (type === "record") {
            // 流水数据
            this.setState(
                {
                    subQueryParams: {
                        page: 1,
                        limit: 20,
                        total: 0,
                        kpoker_mode: -1,
                        origin_id: undefined,
                        origin_ids: [],
                        game_kind: undefined,
                        date: [],
                    },
                },
                () => {
                    this.fetchRecordData();
                }
            );
        } else {
            // 表格数据
            this.setState(
                {
                    queryParams: {
                        page: 1,
                        limit: 20,
                        total: 0,
                        kpoker_mode: -1,
                        origin_id: undefined,
                        origin_ids: [],
                        date: [],
                    },
                },
                () => {
                    this.fetchData();
                }
            );
        }
    };

    /**
     * 显示弹窗
     */
    handleShow = () => {
        this.setState(
            {
                show: true,
                title: this.props.language["openConsumeRecord"],
                recordData: [],
                subQueryParams: {
                    ...this.state.subQueryParams,
                    page: 1,
                    limit: 20,
                },
            },
            () => this.fetchRecordData()
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    {Cookie.get("unionType") === "super_union" && (
                        <Cascader
                            showSearch
                            allowClear
                            options={this.state.subUnionList}
                            placeholder={this.props.language["unionPlaceholder"]}
                            value={this.state.queryParams.origin_ids}
                            displayRender={(label) => label[1]}
                            onChange={(value) => this.handleSetQueryParamsData("origin_ids", value)}
                        />
                    )}
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                    <Button type="primary" ghost onClick={this.handleShow}>
                        {this.props.language["openConsumeRecord"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.state.data, "day")}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="day"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cusomeOrigin"]}
                            dataIndex="origin"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalCusome"]}
                            dataIndex="total_cost"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["nlh"]}
                            dataIndex="nlh"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aof"]}
                            dataIndex="aof"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["six"]}
                            dataIndex="six"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["plo"]}
                            dataIndex="plo"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofc"]}
                            dataIndex="ofc"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mtt"]}
                            dataIndex="mtt"
                        />
                    </Table>
                    <Pagination
                        className="pagination"
                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>

                {/* 查看流水弹窗 */}
                <RecordModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    loading={this.state.recordLoading}
                    exportRecordLoading={this.state.exportRecordLoading}
                    subQueryParams={this.state.subQueryParams}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        current: this.state.subQueryParams.page,
                        pageSize: this.state.subQueryParams.limit,
                        total: this.state.subQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    recordData={this.state.recordData}
                    subUnionList={this.state.subUnionList}
                    kindList={this.state.kindList}
                    handleSetQueryParamsData={this.handleSetQueryParamsData}
                    handleReset={this.handleReset}
                    fetchRecordData={this.fetchRecordData}
                    handleRecordExport={this.handleRecordExport}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(current, pageSize) =>
                        this.hanldeChangePage({ current, pageSize }, "record")
                    }
                    onShowSizeChange={(current, pageSize) =>
                        this.hanldeChangePage({ current, pageSize }, "record")
                    }
                />
            </div>
        );
    }
}

/**
 * 查看流水弹窗
 */
class RecordModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: '70vh',
                    overflowY: "auto",
                }}
                footer={
                    <Pagination
                        {...this.props.pagination}
                        onChange={this.props.onChange}
                        onShowSizeChange={this.props.onShowSizeChange}
                    />
                }
            >
                {/* 表头 */}
                <div className="container-header">
                    {Cookie.get("unionType") === "super_union" && (
                        <Cascader
                            showSearch
                            allowClear
                            options={this.props.subUnionList}
                            placeholder={this.props.language["unionPlaceholder"]}
                            value={this.props.subQueryParams.origin_ids}
                            displayRender={(label) => label[1]}
                            onChange={(value) => this.props.handleSetQueryParamsData("origin_ids", value, "record")}
                        />
                    )}
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        className="mr10"
                        placeholder={this.props.language["gameTypePlaceholder"]}
                        value={this.props.subQueryParams.game_kind}
                        onChange={(value) =>
                            this.props.handleSetQueryParamsData("game_kind", value, "record")
                        }
                    >
                        {this.props.kindList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        className="mr10"
                        value={this.props.subQueryParams.date}
                        onChange={(e) =>
                            this.props.handleSetQueryParamsData("date", e, "record")
                        }
                    />
                    <Button
                        type="primary"
                        icon="search"
                        className="mr10"
                        onClick={this.props.fetchRecordData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button
                        type="default"
                        icon="reload"
                        className="mr10"
                        onClick={() => this.props.handleReset("record")}
                    >
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.props.exportRecordLoading}
                        onClick={this.props.handleRecordExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.props.recordData}
                        pagination={false}
                        loading={this.props.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="ts"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cusomeAmount"]}
                            dataIndex="num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cusomeOrigin"]}
                            dataIndex="origin"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex=""
                            render={(item) =>
                                this.props.kindList.find(
                                    (item2) => item2.value === item.game_kind
                                ) ? this.props.kindList.find(
                                    (item2) => item2.value === item.game_kind
                                ).label
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex="mid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleName"]}
                            dataIndex="match_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["level"]}
                            dataIndex="sb_bb_ante"
                        />
                    </Table>
                </div>
            </Modal>
        );
    }
}
